/**
 * 병의원·약국 공공 데이터 수집 배치(facilityCollectionJob) 수동 실행 API.
 *
 * 월·수·금 새벽 정기 수집이 실패했을 때 관리자가 직접 다시 돌리기 위한 용도다.
 * 서버는 요청을 접수하면 바로 202 를 돌려주며, 진행·완료 조회 API 는 없다(결과는 Slack 알림).
 */
import { apiClient } from '@/shared/api/http-client';
import { createApiPath } from '@/shared/api/endpoints';
import { isAxiosError } from 'axios';

/** baseYm 이 숫자 6자리(yyyyMM)가 아니면 400 + 이 코드 */
export const INVALID_BASE_YM_FORMAT_CODE = 'INVALID_BASE_YM_FORMAT';

export interface FacilityCollectionRunResponse {
  /** 항상 ACCEPTED — 접수일 뿐 배치 완료가 아니다 */
  status: string;
}

export const isInvalidBaseYmFormatError = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;
  const data = error.response?.data as { code?: unknown } | undefined;
  return data?.code === INVALID_BASE_YM_FORMAT_CODE;
};

export const facilityCollectionService = {
  /** baseYm 을 비우면 파라미터 없이 보내 서버가 현재 연월로 실행한다 */
  run: async (baseYm?: string): Promise<FacilityCollectionRunResponse> => {
    const response = await apiClient.post(
      createApiPath.facilityCollection.run(),
      undefined,
      { params: baseYm ? { baseYm } : undefined },
    );
    return response.data;
  },
};
